import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { formatDate, formatEur, formatAmount, RATE_SOURCE_LABELS } from '../../lib/workStatus';
import { ChevronDown, ChevronUp, Trash2 } from 'lucide-react';

export const SalaryLinesTable = ({ summary, onDeleteEntry }) => {
  const [showDetails, setShowDetails] = useState(false);
  const details = summary.entry_details || [];

  return (
    <Card className="border-0 shadow-sm" data-testid="admin-salary-lines">
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle className="text-base">Darbi pēc darba veidiem ({summary.approved_entries} apstiprināti ieraksti)</CardTitle>
        {details.length > 0 && (
          <Button size="sm" variant="ghost" onClick={() => setShowDetails((v) => !v)} data-testid="admin-salary-toggle-details">
            {showDetails ? <ChevronUp className="w-4 h-4 mr-1" /> : <ChevronDown className="w-4 h-4 mr-1" />} {showDetails ? 'Paslēpt ierakstus' : 'Rādīt katru ierakstu'}
          </Button>
        )}
      </CardHeader>
      <CardContent className="p-0">
        {summary.lines.length === 0 ? <p className="px-6 pb-6 text-sm text-[#2E2E2E]/60" data-testid="admin-salary-lines-empty">Šajā mēnesī nav apstiprinātu darbu.</p> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-[#f8faf8] text-left"><tr><th className="px-6 py-3">Darba veids</th><th className="px-6 py-3 text-right">Apjoms</th><th className="px-6 py-3">Mērvienība</th><th className="px-6 py-3 text-right">Likme</th><th className="px-6 py-3 text-right">Summa</th></tr></thead>
              <tbody className="divide-y divide-gray-100">
                {summary.lines.map((line, i) => (
                  <tr key={`${line.work_type}-${line.rate}-${i}`} data-testid={`admin-salary-line-${line.work_type}`}>
                    <td className="px-6 py-3 font-medium">{line.label}</td>
                    <td className="px-6 py-3 text-right">{formatAmount(line.amount)}</td>
                    <td className="px-6 py-3">{line.unit}</td>
                    <td className="px-6 py-3 text-right">{formatEur(line.rate)} / {line.unit}</td>
                    <td className="px-6 py-3 text-right font-semibold">{formatEur(line.total)}</td>
                  </tr>
                ))}
                <tr className="bg-[#f8faf8] font-semibold"><td className="px-6 py-3" colSpan={4}>Darbi kopā</td><td className="px-6 py-3 text-right" data-testid="admin-salary-work-total">{formatEur(summary.work_total)}</td></tr>
              </tbody>
            </table>
          </div>
        )}
        {showDetails && details.length > 0 && (
          <div className="border-t border-gray-100 overflow-x-auto" data-testid="admin-salary-details">
            <table className="w-full text-xs">
              <thead className="bg-white text-left text-[#2E2E2E]/60"><tr><th className="px-6 py-2">Datums</th><th className="px-6 py-2">Objekts / uzdevums</th><th className="px-6 py-2">Darba veids</th><th className="px-6 py-2 text-right">Apjoms</th><th className="px-6 py-2 text-right">Likme</th><th className="px-6 py-2 text-right">Summa</th>{onDeleteEntry && <th className="px-6 py-2" />}</tr></thead>
              <tbody className="divide-y divide-gray-50">
                {details.map((d) => (
                  <tr key={d.id} data-testid={`admin-salary-detail-${d.id}`}>
                    <td className="px-6 py-2 whitespace-nowrap">{formatDate(d.date)}</td>
                    <td className="px-6 py-2">{d.project_name ? `${d.project_name} · ` : ''}{d.task_title}{d.source === 'admin' && <Badge variant="outline" className="ml-1 text-[10px] font-normal">admins</Badge>}</td>
                    <td className="px-6 py-2">{d.label}</td>
                    <td className="px-6 py-2 text-right whitespace-nowrap">{formatAmount(d.amount, d.unit)}</td>
                    <td className="px-6 py-2 text-right whitespace-nowrap">{formatEur(d.rate)}{d.rate_source && <Badge variant="outline" className="ml-1 text-[10px] font-normal">{RATE_SOURCE_LABELS[d.rate_source] || d.rate_source}</Badge>}</td>
                    <td className="px-6 py-2 text-right font-medium">{formatEur(d.total)}</td>
                    {onDeleteEntry && <td className="px-6 py-2 text-right"><Button size="sm" variant="ghost" onClick={() => onDeleteEntry(d)} data-testid={`admin-salary-detail-delete-${d.id}`}><Trash2 className="w-3.5 h-3.5 text-red-600" /></Button></td>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
